import invariant from 'invariant';
import React, { useMemo } from 'react';

import { FilestackImageFit } from 'api/types/shared.types';
import { Subsite } from 'api/website';
import { FilestackImage } from 'components/Image';
import { isDefined, randomInt } from 'utils/functional';

const makeKey = (id: string) => `placeholderImg:${id}`;

type Props = {
  postId: string;
  subsite: Subsite;
  alt: string;
  height: number;
  width: number;
  fit: FilestackImageFit;
  round?: boolean;
  'data-qa-id'?: string;
};

export function PlaceholderImage({
  alt,
  postId,
  subsite,
  height,
  width,
  fit,
  round,
  'data-qa-id': dataQaId,
}: Props) {
  invariant(
    isDefined(localStorage),
    'Placeholder image uses local storage (browser)'
  );

  const storedHandle = localStorage.getItem(makeKey(postId));
  const randomItem = useMemo(
    () =>
      subsite.placeholderImages[randomInt(subsite.placeholderImages.length)],
    [subsite.placeholderImages]
  );

  const image =
    subsite.placeholderImages.find((i) => i.handle === storedHandle) ||
    (() => {
      localStorage.setItem(makeKey(postId), randomItem.handle);
      return randomItem;
    })();

  return (
    <FilestackImage
      data={image}
      alt={image?.altText || alt}
      height={height}
      width={width}
      fit={fit}
      round={round}
      data-qa-id={dataQaId}
    />
  );
}
